import React,{Component} from "react";
import "./header/Header.css";
import "../scss/general.css";
import logo from "./images/loading.gif";
import Moment from "moment";
//import ModalLogin from './ModalLogin';
//import Mymodal from './modal';
import Cookies from "universal-cookie";
import ReactToPdf from "react-to-pdf";
import config from '../config';
import logonotfound from './images/recordnotfound.png';

import  { DownloadTableExcel } from "react-export-table-to-excel";
const cookies = new Cookies();
const axios = require("axios");
const ref = React.createRef(null);
export default class AttendanceDuringDate extends Component {
    constructor(props) {
        super(props);
        this.state = {
        islocation:true,
        isLoaded: true,
        input:{},
        myitems: [],
        statustext:[],
        ErrMsg:"", //<img src={logo} alt="Error"/>,
        ErrMsg2:"",
        today: new Date(),
        cMonth:new Date().getMonth(),
        cYear:new Date().getFullYear(),
        sValue:new Date(),
        eValue:new Date(),
        DivClass: "ErrDiv",
        minDate:'',
        maxDate:'',
        EmpID:'',
        name:'',
        location:'',
        divxls:'none',
        department:'',
        leaveclass: "tdm"
        }
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleLoadData=this.handleLoadData.bind(this);
    }
    handleInputChange = (e)=> {
        this.setState({EmpID: e.target.value,divxls:"none",myitems:[]});
      }
      handleFocus(event){event.target.select();}
  
  
    cur=(num)=> {
        if(num > 0)
            return num.toFixed(1).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
        else
            return "-"
    }
    handleChange=(e)=>{
        if(e.target.name=="start")
        {
            this.setState({sValue:e.target.value,divxls:"none",myitems:[]});
        }
        else
        {
            this.setState({eValue:e.target.value,divxls:"none",myitems:[]});
        }   
    }
    handleSubmit=(e)=>{
    }
    handleLoadData(){
        document.body.style.cursor="wait";
        let input=this.state.input;
        let loginid=this.state.EmpID;
        input["id"]=this.state.EmpID;
        input["start"]=Moment(this.state.sValue).format("DD/MM/YYYY");
        input["end"]=Moment(this.state.eValue).format("DD/MM/YYYY");
        console.log(input);

        this.setState({input,isLoaded:true,ErrMsg:<img src={logo} alt=""/>,myitems:[],divxls:"none"});
        axios.all([
            axios({
                method: 'post',
//                url: cookies.get("phpclass")+'/index.php/user/get_attendance/'+loginid+"/"+this.state.cMonth+"/"+this.state.cYear, // +this.state.month,
                url: cookies.get("phpclass")+'/index.php/user/get_attendance_period/',
                data:input,
                headers: {'Content-Type': 'multipart/form-data'}
            }),
            axios({
                method: 'post',
                url: cookies.get("phpclass")+'/index.php/user/get_employee/'+loginid, // +this.state.month,
                headers: {'Content-Type': 'multipart/form-data'}
            })
        ])           
        .then(axios.spread((response,response1)=> {
            console.log(response.data);
            document.body.style.cursor="default";
            this.setState({
            isLoaded: true,
            islocation:true,
            ErrMsg:"",
            name:response1.data[0]["name"],
            location:response1.data[0]["location"],
            department:response1.data[0]["department"],
            divxls:'block',
            myitems: response.data
            });
        }))
        .catch((response)=> {
            document.body.style.cursor="default";
            this.setState({ErrMsg:<img src={logonotfound} alt=""/>});
        });  
    }

    componentDidMount(){
//        let ccdate=new Date();
/*        if(cookies.get("LoginID"))
        {  
            let cmonth=this.state.cMonth;
            let cyear=this.state.cYear;
            if(cmonth >= 7 && cmonth <= 12)
                this.setState({minDate:cyear +"-07",maxDate: (cyear+1)+"-06"});
            else
                this.setState({minDate:(cyear-1) +"-07",maxDate: cyear+"-06"});
        }
        else
        {
            this.setState({ErrMsg:<ModalLogin mTitle={config.gvr.ErrMsgs.TitleNotLoggedin} mBody={config.gvr.ErrMsgs.MsgNotLoggedin}/>});
        }*/
    
    }
    render(){
        let isLoaded = this.state.isLoaded;
        let items = this.state.myitems;     
        let fileName=this.state.name+"-attendance.pdf";

        if (!isLoaded ) 
        {
            return(
              <div className="center">
                {this.state.ErrMsg}
              </div>
            );
        } 
        else 
        {
            return(
            <div width="100%" align="center" >
            <br></br>
            <div className="inner-profile33" >
            <span className="box-title">Attendance</span>

            <div className="inner-profile2" >

                <label style={{width:"100px"}} >Employee ID:</label>
                <input style={{width:100}}
                    autoFocus="autofocus"
                    name="EmpID"
                    placeholder="Employee Id"
                    onChange={this.handleInputChange}
                    onFocus={ this.handleFocus}
                />
            <br></br>
            <label style={{width:"100px"}} >Select Date: </label>
{/*}            <input style={{paddingLeft:5}} type="month" id="start" name="start" min={this.state.minDate} max={this.state.maxDate} onChange={this.handleChange} value={this.state.cValue} />*/}
            <input style={{paddingLeft:5}} type="date" id="start" name="start"  onChange={this.handleChange} value={this.state.sValue} />
            <label style={{marginLeft:2}} >-</label>
            <input style={{marginLeft:3}} type="date" id="end" name="end"  onChange={this.handleChange} value={this.state.eValue} />

            <button type="submit" style={{background: "linear-gradient(to bottom , #ffffff 0%, white 100%)", marginLeft:5}} onClick={this.handleLoadData}>Submit </button>
            </div>
            <div style={{textAlign:"center",width:"100%" }} ref={ref}>
            <br></br>

            <div style={{textAlign:"left",width:"100%", display:this.state.divxls,marginTop:0}} >
            
            <h6>{this.state.name}</h6>            
            <h6>{this.state.location} - {this.state.department}</h6>
            <h7>From {Moment(this.state.sValue).format("DD/MM/YYYY")} - {Moment(this.state.eValue).format("DD/MM/YYYY")}</h7>

{/*}            <span>For the month of {this.state.cMonth}, {this.state.cYear}</span>*/}
            </div>
            <table style={{width:"100%",paddingLeft:"1%",paddingTop:"10px",border: "1px dotted black"}} id="tablexls" >
            <thead>
                <tr className="tr">
                    <th className="th" scope="col">Date</th>
                    <th className="th" scope="col">Day</th>
                    <th className="th" scope="col">Time in</th>
                    <th className="th" scope="col">Time out</th>
                    <th className="th" scope="col">Hours</th>
                    <th className="th" scope="col">Holiday / Off</th>
                    <th className="th" scope="col">Status</th>
                </tr>
            </thead>
            <tbody>
            {
                items.map((result ,i) => {
                let leavedays='';
                let attclass="tdm";
                if(result.leavetype == "VA" && result.from_time == "9:00 AM" && result.to_time == "1:00 PM")
                {
                    leavedays="VA ("+result.reason+") 1st half by "+result.ARbyname;
                    attclass="tdmva";
                }
                if(result.leavetype == "VA" && result.from_time == "1:00 PM" && result.to_time == "5:00 PM")
                {
                    leavedays="VA ("+result.reason+") 2nd half by "+result.ARbyname;
                    attclass="tdmva";
                }
                if(result.leavetype == "VA" && result.from_time == "9:00 AM" && result.to_time == "5:00 PM")
                {
                    leavedays="VA ("+result.reason+") full day by "+result.ARbyname;
                    attclass="tdmva";
                }

                if(result.leaveday == 0.5 && result.leavetype !== "VA" )
                {
                    leavedays='half day '+result.leavetype;
                    attclass="tdmleaves";
                }
                else if (result.leaveday == 1 && result.leavetype !== "VA")
                {
                    leavedays='1.0 day '+ result.leavetype;
                    attclass="tdmleaves";
                }

                if(result.timein==null && result.timeout==null && result.dayname!=="Sunday" && result.holidays.length == 0 && result.leaveday==null && new Date(result.cdate)<=new Date())
//                if(result.timein==null && result.timeout==null && result.dayname!=="Sunday" && result.holidays.length == 0 && result.leaveday==null && Moment(result.cdate).format("DD/MM/YYYY")<=Moment(new Date()).format("DD/MM/YYYY") )
{
                    leavedays='Absent  ';
                    attclass="tdmabsent";
                }
/*                if(result.timein > "10:30:00"  && result.dayname!=="Sunday" && result.holidays.length == 0 && result.leaveday==null && new Date(result.cdate)<=new Date() )
                {
                        leavedays='Absent 1st half ';
                        attclass="tdmabsent";
                }
                if(result.timeout < "15:30:00"  && result.dayname!=="Sunday" && result.holidays.length == 0 && result.leaveday==null && new Date(result.cdate)<=new Date() )
                {
                        leavedays='Absent 2nd half ';
                        attclass="tdmabsent";
                }
*/    
                if(result.dayname == "Sunday")
                {
                    attclass="tdmsunday";
                }
                if(result.holidays.length > 1)
                {
                    attclass="tdmholiday";
                }
                return(
                    <tr className="trc" key={i}>
                        <td className={attclass}>{Moment(result.cdate).format("DD/MM/YYYY")}</td>
                        <td className={attclass}>{result.dayname}</td>
                        <td className={attclass}>{result.timein}</td>
                        <td className={attclass}>{result.timeout}</td>
                        <td className={attclass}>{result.hours}</td>
                        <td className={attclass}>{result.holidays}</td>
                        <td className={attclass}>{leavedays}</td>
                    </tr>
                )
                        
            })}

            </tbody>
        </table>
        </div>

        <div style={{textAlign:"center",paddingTop:5,display:this.state.divxls}} >
            <DownloadTableExcel
                filename={this.state.EmpID+"_Hours"}
                sheet="users"
                currentTableRef={ref.current}
                >
                <button style={{background:"linear-gradient(to bottom , #ffffff 0%, black 100%)"}}> Export excel </button>
            </DownloadTableExcel>
            <ReactToPdf targetRef={ref} filename={fileName} x={10} scale={0.9}>
                  {({toPdf}) => (
                    <button onClick={toPdf} style={{background:"linear-gradient(to bottom , #ffffff 0%, black 100%)"}}>Download pdf</button>
                  )}
                </ReactToPdf>

        </div>


        </div>
        <br></br><br></br>
        {this.state.ErrMsg}
        </div>
        );
    }
}}
